import * as Sentry from '@sentry/react';
import { PROD_ENVIRONMENT } from '@appscore/web-constants/environments';

let initialized = false;

const isExternalUrl = (url) => {
  if (!url) return false;
  if (url.startsWith('/') || !url.includes('://')) return false;
  if (typeof window !== 'undefined' && window.location) {
    const origin = window.location.origin;
    if (url === origin || url.startsWith(origin + '/')) {
      return false;
    }
  }
  return true;
};

const getSpanUrl = (span) => {
  if (!span) return '';
  if (span.data && span.data['http.url']) return span.data['http.url'];
  if (span.description) {
    const parts = span.description.split(' ');
    if (parts.length > 1 && ['GET', 'POST', 'PUT', 'DELETE', 'PATCH'].includes(parts[0])) {
      return parts[1];
    }
    return span.description;
  }
  return '';
};

const beforeSendTransaction = (event) => {
  if (event.spans) {
    event.spans = event.spans.filter((span) => {
      if (span.op && span.op.startsWith('resource')) return false;
      if (span.op === 'http.client' && isExternalUrl(getSpanUrl(span))) return false;
      return true;
    });
  }
  return event;
};

const sentryHub = {
  init: ({ dsn, environment }) => {
    if (typeof window === 'undefined' || initialized) return;

    const isLive = environment === PROD_ENVIRONMENT;

    Sentry.init({
      dsn,
      environment,
      release: `${APP_NAME}@${APP_VERSION}`,
      tracesSampleRate: isLive ? 0.1 : 1,
      sampleRate: isLive ? 0.1 : 1,
      integrations: [
        Sentry.browserTracingIntegration({
          enableInp: true,
        }),
      ],
      beforeSendTransaction,
    });

    initialized = true;
  },
  captureMessage: (message) => {
    if (!initialized) return null;
    Sentry.captureMessage(message);
  },
  captureException: (ex) => {
    if (!initialized) return null;
    Sentry.captureException(ex);
  },
  setTag: (key, value) => {
    if (!initialized) return null;
    Sentry.setTag(key, value);
  },
  setUser: (user) => {
    if (!initialized) return null;
    Sentry.setUser(user);
  },
  withScope: (cb) => {
    if (!initialized) return null;
    Sentry.withScope(cb);
  },
  addNavigation: (to) => {
    if (!initialized) return null;
    Sentry.addBreadcrumb({ type: 'navigation', category: 'navigation', data: { to } });
  },
};

Object.freeze(sentryHub);

export { sentryHub };
